module.exports = __webpack_public_path__ + "img/9788952763969.19f062a8.jpg";